export function getDefaultPaymentMethods() {
  var paymentMethods = [];
  paymentMethods.push({
    name: "Nakit",
    id: parseInt(process.env.VUE_APP_CASH_PAYMENT_ID),
    posPaymentTypeId: (process.env.VUE_APP_POS_PAYMENT_CASH)
  });
  paymentMethods.push({
    name: "Kredi Kartı",
    id: parseInt(process.env.VUE_APP_CREDIT_PAYMENT_ID),
    posPaymentTypeId: (process.env.VUE_APP_POS_PAYMENT_CREDIT)

  });
  paymentMethods.push({
    name: "Cari",
    id: parseInt(process.env.VUE_APP_CARI_PAYMENT_ID),
    posPaymentTypeId: (process.env.VUE_APP_POS_PAYMENT_CARI)

  });
  paymentMethods.push({
    name: "Kasa Nakit",
    id: 25,
    posPaymentTypeId: 25

  });
  return paymentMethods;
}
